import { createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
import { handleExport } from '../../../../../../helpers/export'
import { getDefaultVsic } from '../../../../helper'
import CorpService from '../../core/CorpService'

export const postAssetManagementEfficiency = createAsyncThunk(
  'companyAnalysis/industryAnalysis/corp/assetManagementEfficiency',
  async (params, { rejectWithValue }) => {
    try {
      if (params?.isDynamicReport) {
        const {
          vsics,
          companyInfo = {},
          defaultIndustryId,
          compareIndustryId,
        } = params

        const defaultVsicId =
          defaultIndustryId || getDefaultVsic(vsics, companyInfo.mainVsicId).id

        const res = await CorpService.postAssetManagementEfficiency({
          vsicDefault: defaultVsicId,
          vsicCompare: compareIndustryId,
          organizationId: companyInfo?.organizationId,
        })

        return res.success
          ? { data: res.data, defaultVsicId }
          : rejectWithValue({ isLoading: false })
      } else {
        const { vsicDefault, ...others } = params
        const res = await CorpService.postAssetManagementEfficiency({
          vsicDefault,
          ...others,
        })

        return res.success
          ? { data: res.data, defaultVsicId: vsicDefault }
          : rejectWithValue({ loading: false })
      }
    } catch (error) {
      return rejectWithValue({ loading: axios.isCancel(error) })
    }
  },
)

export const downloadAssetManagementEfficiency = createAsyncThunk(
  'companyAnalysis/industryAnalysis/corp/assetManagementEfficiency/export',
  async (params) => {
    try {
      const res = await CorpService.downloadAssetManagementEfficiency(params)
      handleExport(res.data, res.filename)
    } catch (error) {
      console.log(error)
    }
  },
)
